module.exports = __webpack_public_path__ + "static/media/ImmaculateConceptionNewburyport.0fc47477.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/ImmaculateConceptionNewburyport.png
// module id = 645
// module chunks = 0